import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";
import { GetHangtagPreview, GetPreviewParameter } from "@tSurya/Services/HangtagPreviewService";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";


export interface HangtagPreviewModel extends BaseModel{
    Html:string;
}

type HangtagPreviewParameter = HasOnSuccess<HangtagPreviewModel> & GetPreviewParameter & HasOnError;

type HandlerType = CustomApiHandler<HangtagPreviewParameter,HangtagPreviewModel>;

export const PopulateApiParameter:HandlerType = props=>{
    props.apiParameter = props.parameter;
}

export const RequestDataFromApi:HandlerType =async props =>{
    try{
        props.apiResult = (await GetHangtagPreview(props.apiParameter)) as unknown as HangtagPreviewModel
       
    }
    catch(error){
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
        }
        
        throw error;
    }
}

export const ExecuteOnSuccessCallback : HandlerType = props =>{
    if(props.apiResult){
        props.parameter.onSuccess?.(props.apiResult);
    }
}

export const chain = [PopulateApiParameter,RequestDataFromApi,ExecuteOnSuccessCallback]

const PreviewHtml = createHandlerChainRunner(chain , "HangtagPreview")
export default PreviewHtml;